export default __webpack_public_path__ + "static/media/EditLogo.a4fd262a.svg";